import React, { useState } from 'react';
import useAuthStore from '../stores/authStore';
import useUserSettingsStore from '../stores/userSettingsStore';
import useDocumentStore from '../stores/documentStore';
import RegistrationPromptModal from './RegistrationPromptModal'; // Импортируем новый компонент
import './DocumentSummary.css'; // Импортируем стили

const DocumentSummary = ({ summary, documentId }) => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [isRegistrationPromptOpen, setIsRegistrationPromptOpen] = useState(false);
  const { isAuthenticated } = useAuthStore();
  const { openSettings } = useUserSettingsStore();
  const documentResult = useDocumentStore(state => state.documentResult);

  const handleSettingsClick = () => {
    if (isAuthenticated) {
      openSettings();
    } else {
      setIsRegistrationPromptOpen(true);
    }
  };

  const renderKeyPoints = (content) => {
    try {
      const data = JSON.parse(content);
      return (
        <ul>
          {data.points.map((point, index) => (
            <li key={index}>
              <h4 className="docsummary__point-title">{point.title}</h4>
              <div className="docsummary__point-content">{point.content}</div>
            </li>
          ))}
        </ul>
      );
    } catch (e) {
      console.error('Failed to parse key points:', e);
      return <div className="docsummary__error">Ошибка обработки ответа</div>;
    }
  };

  return (
    <div className="docsummary__container">
      <div className="docsummary__header">
        <h3 className="docsummary__title">Ключевая информация из документа</h3>
        <button 
          className="docsummary__settings-link" 
          onClick={handleSettingsClick}
        >
          Настройте ключевые пункты для будущих документов
        </button>
      </div>
      <div className="docsummary__content">
        {renderKeyPoints(summary)}
      </div>
      {isRegistrationPromptOpen && (
        <RegistrationPromptModal onClose={() => setIsRegistrationPromptOpen(false)} />
      )}
    </div>
  );
};

export default DocumentSummary; 
